/**
 * Profanity filter for game nicknames.
 * Covers Russian mat (Cyrillic + Latin transliteration) and English profanity.
 * Normalizes separators, repeated chars, digit substitutions before matching.
 */

function normalize(s) {
  s = s.toLowerCase();
  // strip separators people insert between letters
  s = s.replace(/[._\-\s*+]/g, '');
  // collapse 3+ identical chars → 2  (huuuuy → huy, хуууй → хуй)
  s = s.replace(/(.)\1{2,}/g, '$1$1');
  // common digit/symbol substitutions
  const subs = { '0':'о', '3':'е', '4':'а', '1':'и', '@':'а', '$':'с', '5':'с', '6':'б', '7':'т' };
  s = s.replace(/[034156780@$]/g, c => subs[c] || c);
  return s;
}

// Cyrillic patterns (direct)
const CYR = [
  /хуй/,       /хуя/,      /хуе/,      /хую/,      /хуи/,
  /хуйн/,      /нахуй/,    /охуе/,     /захуй/,    /похуй/,
  /пизд/,      /пиздец/,   /пиздос/,
  /блядь/,     /блять/,    /бляд/,
  /ёбать/,     /ебать/,    /ёбан/,     /ебан/,     /ёба/,      /еба/,
  /ёб$/,       /заёб/,     /заеб/,     /заёб/,     /ёбнут/,
  /сука/,
  /мудак/,     /мудил/,
  /пидор/,     /пидар/,    /педераст/,
  /залупа/,
  /шлюха/,     /шлюх/,
  /манда/,
  /дрочи/,     /дроч/,
  /хуйло/,
  /пиздат/,
];

// Latin transliteration patterns (normalized string — no separators, digits mapped)
const LAT = [
  /[hx]u+[iyj]/,           // hui, xui, huy, xuj
  /[hx]u+[iy]n[iy]/,       // xuiny, huiny
  /na[hx]u+[iy]/,          // nahui, naxui
  /o[hx]u+[ey]/,           // ohue, oxue
  /za[hx]u/,               // zahui
  /po[hx]u/,               // pohui
  /pi+z+d/,                // pizd*
  /pizde[cs]/,             // pizdec
  /pizdos/,
  /bl+[iy]+a*[dt]/,        // bliad, blyd, bliat
  /blyd/,
  /[ye]+b[aou]+[tln]/,     // ebat, yebat, ebut
  /yo+b/,                  // yob
  /[ye]+b[ao]n/,           // eban, yoban
  /za[ye]b/,               // zaeb, zayeb
  /[ye]ba[lni]/,           // ebal, yebali
  /su+k+[aiy]/,            // suka
  /mu+d[ai]+[kc]/,         // mudak
  /mudil/,
  /pid[ao]r/,              // pidor, pidar
  /pidar/,
  /pederast/,
  /zalup/,
  /shl+[uy]+[hk]/,         // shljuha, slukha
  /man+d[aeo]/,            // manda
  /[hx]u+[iy]l/,           // khuilo, huilo
  /droch/,
  /[ye]ban[iy]/,           // ebany
  // English
  /fu+c+k/,
  /sh[i1]+t+/,
  /bi+tc+h/,
  /cu+n+t/,
  /ni+g+[ae]r/,
  /nigg[ae]/,
  /as+h[o0]le/,
  /motherfuc?k/,
  /dickhead/,
  /pu+ss+[yi]/,
  /wh[o0]+r+e/,
  /sl+u+t+/,
  /fagg?[o0]t/,
];

export function containsProfanity(text) {
  if (!text) return false;
  // Check original text against Cyrillic patterns
  const lower = text.toLowerCase();
  for (const pat of CYR) {
    if (pat.test(lower)) return true;
  }
  // Check normalized text against Latin patterns
  const norm = normalize(text);
  for (const pat of LAT) {
    if (pat.test(norm)) return true;
  }
  return false;
}
